export default class LocalStorage {
  static removeItem(key) {
    localStorage.removeItem(key);
  }

  static setItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  static getItem(key) {
    let value = null;

    try {
      value = JSON.parse(localStorage.getItem(key));
    } catch (err) {}

    return value;
  }

  /**
   * Returns the parsed 'session' object from localStorage, or null.
   * Removes the key if the stored value is corrupt or unparseable.
   */
  static getSession() {
    const raw = localStorage.getItem('session');
    if (!raw || raw === 'undefined') {
      return null;
    }
    try {
      return JSON.parse(raw);
    } catch {
      localStorage.removeItem('session');
      return null;
    }
  }
}
